import React from 'react';
import { Callout, List, Only, P, Steps, Sub, Table, UI } from '../ui';

export const Notifications: React.FC = () => (
  <>
    <Sub anchor="notifications-incoming">새 메시지가 오면 이렇게 알려줍니다</Sub>
    <Table
      head={['환경', '알림 방식']}
      rows={[
        [
          <>
            PC 앱 <Only env="desktop" />
          </>,
          'Windows 알림 팝업 + 작업표시줄 아이콘이 빨갛게 깜빡이며 안 읽은 개수 표시 + 앱 화면이 잠깐 파랗게 번쩍임',
        ],
        [
          <>
            웹 브라우저 <Only env="web" />
          </>,
          '브라우저 알림 + 탭 제목이 "[새 메시지] 대화방 이름"으로 번갈아 표시',
        ],
      ]}
    />
    <P>
      알림 제목은 대화방 이름입니다. 여러 명이 있는 대화방에서는 <b>내용 앞에 보낸 사람 이름이 함께</b> 표시되어
      누가 보냈는지 바로 알 수 있습니다. 1:1 대화는 제목이 이미 상대방 이름이라 따로 붙지 않습니다.
    </P>
    <P>
      알림 팝업을 클릭하면 창이 앞으로 나오면서 해당 대화방으로 바로 이동합니다. 창을 다시 클릭해 앞으로 가져오면
      깜빡임은 자동으로 멈춥니다.
    </P>
    <P>
      지금 보고 있는 대화방의 메시지는 알림이 뜨지 않습니다. 다른 대화방의 메시지이거나 앱이 뒤에 있을 때만
      알려줍니다.
    </P>
    <P>
      PC 앱이나 PC 브라우저에서 사용 중이면 <b>휴대폰으로는 알림이 오지 않습니다</b>. PC를 5분 이상 쓰지 않거나
      PC 앱을 종료하면 그다음 메시지부터 휴대폰으로 다시 옵니다. PC 앱은 다른 프로그램을 쓰는 동안도 사용 중으로
      보고, PC 브라우저는 INA-TALK 탭에서 마우스나 키보드를 쓴 경우만 사용 중으로 봅니다.
    </P>
    <P>
      휴대폰에 알림이 떠 있는 대화를 PC에서 읽으면 <b>휴대폰 알림이 몇 초 안에 자동으로 사라지고</b> 앱 아이콘의
      숫자도 맞춰집니다(안드로이드). 아이폰은 iOS 제한 때문에 다음에 앱을 열 때 정리됩니다.
    </P>

    <Callout tone="info" title="알림에 무엇까지 표시할지 고를 수 있습니다">
      <p>
        기본값은 <b>전체 표시</b>입니다. <UI>설정</UI> → <UI>알림</UI> → <UI>알림에 표시할 내용</UI>에서{' '}
        <b>보낸 사람만</b> 또는 <b>전부 숨김</b>으로 바꾸면 PC 앱 알림 팝업과 브라우저 알림에 메시지 내용이 나오지
        않습니다. 이 설정은 기기가 아니라 계정에 저장되므로 로그인한 모든 기기에 함께 적용됩니다.
      </p>
      <p>
        <b>휴대폰 푸시 알림에는 어떤 설정에서도 메시지 내용이 나오지 않습니다</b> — 보안을 위해 서버가 내용을 아예
        보내지 않기 때문입니다. 대화방 이름과 보낸 사람 이름은 표시되므로 어느 방의 누구인지는 알 수 있습니다.
        로그아웃 상태의 PC 앱 알림에는 발신자도 표시되지 않습니다.
      </p>
    </Callout>

    <Sub>전화가 올 때</Sub>
    <P>
      화상통화는 메시지와 규칙이 다릅니다. <b>PC를 쓰고 있어도 전화 알림은 휴대폰으로 옵니다</b> — 자리를 비운
      사이 전화를 놓치면 복구할 방법이 없기 때문입니다. 대화방 알림을 꺼 두어도 전화벨은 울립니다.
    </P>
    {/* List는 items prop이 없다(children만) — items로 넘기면 조용히 빈 목록이 렌더된다 */}
    <List>
      <>다른 기기에서 전화를 받거나 거절하면, 울리던 휴대폰 알림은 자동으로 꺼집니다.</>
      <>아무도 받지 않은 채 통화가 끝나면 알림이 &ldquo;부재중 통화&rdquo;로 바뀝니다.</>
      <>전사 공지처럼 참여자가 많은 공개 대화방에서는 전화 알림을 보내지 않습니다.</>
    </List>
    <Callout tone="info" title="아이폰은 전화 알림이 짧게만 표시됩니다">
      <p>
        아이폰은 앱이 완전히 꺼져 있으면 전화 알림을 화면에 붙잡아 둘 수 없어, 잠금 화면에 잠깐 떴다가
        사라집니다. 전화를 자주 받아야 한다면 PC 앱을 함께 켜 두시길 권합니다.
      </p>
    </Callout>

    <Sub anchor="notifications-activity">알림함 — 멘션·답장·반응 모아보기</Sub>
    <P>
      나와 관련된 일들만 따로 모아 보는 곳입니다. 누가 나를 <b>@멘션</b>했는지, 내 메시지에 <b>답장</b>하거나{' '}
      <b>이모지 반응</b>을 남겼는지가 시간순으로 쌓입니다.
    </P>
    <List>
      <>
        PC에서는 왼쪽 세로 탭의 <b>종 모양(알림)</b> 탭, 휴대폰에서는 <b>홈 화면 오른쪽 위 종 아이콘</b>(또는
        설정 탭의 <UI>알림함</UI>)으로 엽니다. 안 읽은 알림 수가 빨간 배지로 표시됩니다.
      </>
      <>항목을 누르면 해당 대화방의 그 메시지 위치로 바로 이동하고, 알림은 읽음 처리됩니다.</>
      <>
        PC에서 알림 탭을 열면 오른쪽에 보던 대화는 닫힙니다. 알림을 누르면 알림 목록은 그대로 둔 채 그 대화가
        오른쪽에 열려, 알림을 차례로 확인할 수 있습니다.
      </>
      <>
        대화방을 열어 읽으면 그 방의 멘션·답장·반응 알림도 함께 읽음 처리됩니다. 알림함에 들어가 따로 지우지
        않아도 됩니다.
      </>
      <>
        오른쪽 위 <UI>모두 읽음</UI>으로 한 번에 정리할 수 있습니다. 여러 기기에 로그인해 두었다면 한 곳에서 읽은
        알림은 다른 기기에서도 함께 사라집니다.
      </>
      <>상대가 이모지 반응을 취소하면 그 알림도 목록에서 사라집니다.</>
    </List>

    <Sub>전자결재 알림 — 알림함의 &lsquo;전자결재&rsquo; 탭</Sub>
    <P>
      인트라넷 전자결재에서 <b>내 결재 차례가 오거나</b>, 내가 올린 문서가 <b>최종 승인·반려</b>되면 알림함에
      알림이 쌓이고 PC 토스트·휴대폰 알림으로도 알려 드립니다. 대화방을 알림 끄기로 해 두어도 결재 알림은 옵니다.
    </P>
    <List>
      <>
        결재 알림이 한 번이라도 오면 알림함 위쪽에 <UI>전체</UI> · <UI>대화</UI> · <UI>전자결재</UI> 탭이 생깁니다.
        <UI>대화</UI> 탭에는 멘션·답장·반응만, <UI>전자결재</UI> 탭에는 결재 알림만 보입니다. 탭마다 안 읽은 수가
        표시되고, <UI>모두 읽음</UI>은 지금 보고 있는 탭에만 적용됩니다.
      </>
      <>
        항목을 누르면 오른쪽(휴대폰은 전체 화면)에 <UI>전자결재</UI> 대화가 열려, 지금까지 받은 결재 알림이
        채팅처럼 시간순 카드로 이어서 보입니다. 누른 알림 위치로 바로 이동하고, 위로 올리면 이전 알림을 더
        불러옵니다. 알림 전용 대화라 답장은 할 수 없습니다.
      </>
      <>
        결재 문서는 카드의 <UI>문서 열기</UI>나 알림함 항목 오른쪽의 바로가기 아이콘으로 엽니다(인트라넷에
        로그인되어 있어야 합니다).
      </>
      <>PC 토스트나 휴대폰 알림을 눌러도 이 대화가 바로 열립니다.</>
      <>
        결재 알림을 받지 않으려면 인트라넷의 개인 알림 설정에서 전자결재 알림을 끄세요. 채팅 앱에도 함께
        적용됩니다.
      </>
    </List>

    <Sub anchor="notifications-calendar">일정 알림 — 알림함의 &lsquo;일정&rsquo; 탭</Sub>
    <P>
      캘린더에서 알림을 켠 일정은 시작 전(10분 전 등)에 알림함 <UI>일정</UI> 탭과 PC 토스트·휴대폰 알림으로 알려
      드립니다. 일정에 초대받거나, 초대받은 일정의 시간이 바뀌거나 취소될 때도 같은 탭으로 옵니다. 알림을 누르면
      캘린더의 그 날짜와 일정이 열립니다. 앱을 보고 있는 중에는 화면 아래 안내로 알려 드립니다. 자세한 내용은{' '}
      <b>캘린더</b> 도움말을 참고하세요.
    </P>

    <Sub>알림 스위치는 다섯 군데에 있습니다</Sub>
    <P>
      &ldquo;알림이 안 온다&rdquo;는 대부분 아래 중 하나가 꺼져 있어서 생깁니다. 위에서부터 순서대로
      확인하세요. 마지막 ⑤는 알림을 끄는 스위치가 아니라 무엇까지 보여줄지를 정하는 설정입니다.
    </P>
    <Table
      head={['위치', '적용 범위', '알아둘 점']}
      rows={[
        [
          <>
            <b key="t">① 트레이 아이콘 우클릭 → 알림 받기</b>
            <Only env="desktop" />
          </>,
          '이 PC 전체',
          <>
            <b>가장 강력한 스위치입니다.</b> 여기를 끄면 앱 안의 어떤 설정으로도 알림을 되살릴 수 없습니다. 껐다
            켠 뒤에도 유지됩니다
          </>,
        ],
        [
          <b key="c">② 대화방 우클릭 → 알림 끄기</b>,
          '그 대화방만',
          '팝업과 깜빡임만 멈춥니다. 안 읽은 개수 배지는 계속 올라가고, 나를 @멘션한 메시지는 음소거 중에도 알림이 옵니다',
        ],
        [
          <b key="w">③ Windows 알림 설정</b>,
          'PC 전체',
          <>
            꺼져 있으면 앱 위쪽에 노란 안내 배너가 뜹니다. 배너의 <UI>알림 설정 열기</UI> 버튼을 누르면 Windows
            설정이 바로 열립니다
          </>,
        ],
        [
          <>
            <b key="m">④ 설정 → 알림 설정 → 이 기기에서 알림 받기</b>
            <Only env="web" />
          </>,
          '이 기기(브라우저)만',
          <>
            웹·모바일 전용 스위치입니다. 끄면 <b>이 기기로만</b> 알림이 오지 않고 PC 앱이나 다른 휴대폰은 그대로
            받습니다. 다시 켤 때까지 유지됩니다
          </>,
        ],
        [
          <b key="p">⑤ 설정 → 알림 → 알림에 표시할 내용</b>,
          '내 계정 전체',
          <>
            알림을 끄는 스위치가 아니라 <b>무엇까지 보여줄지</b>를 정합니다. 기기가 아니라 계정 설정이라 PC에서
            바꾸면 휴대폰에도 함께 적용됩니다
          </>,
        ],
      ]}
    />

    <Sub>로그아웃한 뒤에도 알림 받기</Sub>
    <P>
      PC 앱에는 로그아웃 상태에서도 새 메시지가 왔다는 사실만 알려주는 기능이 있습니다. 기본으로 켜져 있으며{' '}
      <UI>설정</UI> → <UI>로그아웃 시에도 알림 받기</UI>에서 끌 수 있습니다. <Only env="desktop" />
    </P>
    <List>
      <>
        알림에는 <UI>새 메시지가 도착했습니다</UI>만 표시되고 <b>보낸 사람, 대화방, 내용은 나오지 않습니다.</b>
      </>
      <>공용 PC에서 자리를 비울 때 로그아웃해 두고도 연락 여부만 확인할 수 있습니다.</>
      <>이 PC에서 한 번도 로그인한 적이 없으면 동작하지 않습니다.</>
    </List>
    <P>
      웹·모바일(브라우저 알림을 허용한 경우)에서도 로그아웃할 때 확인 창의{' '}
      <UI>로그아웃 후에도 알림 받기</UI> 체크(기본 켜짐)를 그대로 두면 로그아웃 상태에서 알림이 계속 옵니다.
      알림에는 대화방 이름과 보낸 사람만 표시되고 내용은 나오지 않습니다. 공용 PC라면 체크를 해제하고
      로그아웃하세요.{' '}
      <Only env="web" />
    </P>

    <Sub>알림이 오지 않을 때 점검 순서</Sub>
    <Steps>
      <>
        <b>트레이 아이콘을 확인하세요.</b> 화면 오른쪽 아래 시계 옆(숨겨진 아이콘 안에 있을 수 있습니다)의
        INA-TALK 아이콘을 마우스 오른쪽 버튼으로 클릭해 <UI>알림 받기</UI>에 체크가 되어 있는지 봅니다.
      </>
      <>
        <b>그 대화방만 안 오는지 확인하세요.</b> 대화방 목록에서 해당 방 이름 옆에 종에 빗금 친 아이콘이 있으면
        음소거 상태입니다. 우클릭 → <UI>알림 켜기</UI>로 되돌립니다.
      </>
      <>
        <b>Windows 알림 설정을 확인하세요.</b> 앱 위쪽에 노란 배너가 보이면 <UI>알림 설정 열기</UI>를 눌러
        INA-TALK 알림을 켭니다. 집중 지원(방해 금지) 기능이 켜져 있어도 알림이 숨겨집니다.
      </>
      <>
        <b>연결 상태를 확인하세요.</b> 화면 위쪽에 &ldquo;서버와 연결이 끊겼습니다&rdquo; 띠가 보이면 네트워크
        문제입니다. 잠시 기다리면 스스로 다시 연결되며, 계속 남아 있으면 앱을 다시 시작하세요.
      </>
    </Steps>

    <Callout tone="warn" title="공지 채널은 앱이 꺼져 있으면 알림이 오지 않습니다">
      <p>
        전사 공지 같은 공개 채널의 메시지는 앱이 실행 중일 때만 알림이 표시됩니다. 앱을 완전히 종료해 두었다면 다음에
        켤 때 확인하게 됩니다.
      </p>
    </Callout>

    <Sub>접속 상태 표시</Sub>
    <P>프로필 사진 오른쪽 아래의 점이 접속 상태입니다. 색은 네 가지입니다.</P>
    <List>
      <>
        <b>초록색 — 접속 중</b>
      </>
      <>
        <b>노란색 — 자리 비움.</b> 5분 동안 PC를 쓰지 않거나 화면을 잠그면 자동으로 바뀌고, 다시 움직이면 초록색으로
        돌아옵니다. 직접 골라 둘 수도 있습니다.
      </>
      <>
        <b>빨간색 — 다른 용무 중.</b> 본인이 직접 고른 경우에만 표시됩니다. 알림이 막히지는 않습니다.
      </>
      <>
        <b>회색 — 오프라인</b>
      </>
    </List>
    <P>
      상태를 직접 고르는 방법은 <b>설정</b> 도움말의 <UI>내 상태</UI>를 참고하세요. 휴대폰만 접속해 있으면 자리
      비움으로 바뀌지 않습니다 &mdash; 휴대폰은 사용 여부를 알 수 없어 접속 중과 오프라인만 표시합니다.
    </P>
    <P>
      PC와 노트북 등 여러 곳에서 접속해 있으면 하나라도 켜져 있는 동안 접속 중으로 표시되고, 마지막 기기까지 꺼져야
      오프라인이 됩니다.
    </P>
  </>
);
